<div fxLayout="column" class="pd-30 h100" >
<!--  <ngx-paypal #paypal-->
<!--              [registerScript]="false" [config]="payPalConfig"></ngx-paypal>-->
  <div class="" fxFlex></div>
  <app-order-details-total *ngIf="
      !checkoutService.createSavingPlanTypes.includes(
        (checkoutService.selectedPaymentRequest | async)?.type
      )
    " style="margin-bottom: 30px" [shippingPrice]="checkoutService.shippingPrice | async" [totalPrice]="checkoutService.totalPrice | async" [taxIncludes]="true" [showDeliveryPrice]="
      checkoutService.redirectToPaymentList.includes(
        (checkoutService.selectedPaymentRequest | async)?.type
      )
    "></app-order-details-total>
</div>

